<template>
  <div :class="finalClass">
    <slot
      ><i class="fas fa-spin fa-circle-notch"></i>
      <span v-if="!emptySlot" class="ml-2">Loading..</span></slot
    >
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "light",
    },
    type: {
      type: String,
      default: "alert",
    },
    emptySlot: {
      type: Boolean,
      default: false,
    },
  },
  name: "Alert",
  computed: {
    finalClass: function () {
      let classes = ["alert", `alert-${this.color}`];
      let finalClass = classes
        .filter((c) => {
          if (c) {
            if (typeof c == "string") {
              return c;
            }
          }
        })
        .join(" ");

      return finalClass;
    },
  },
};
</script>
